import {Suspense, lazy} from 'react'
import Loader from "../../customs/loader/main"


const Main = lazy(() => import("../../components/settings/Setups/events/main"))

const EventSetup = () => {
  return (
    // <Layout >
        <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
    // </Layout>
    
  )
}

export default EventSetup